import { Injectable } from "@angular/core";
import { ToastController } from "@ionic/angular";
import { ToastFacadeService } from "./toast-facade.service";

@Injectable({
  providedIn: "root",
})
export class ToastService {
  constructor(private toastController: ToastController, private toastFacade: ToastFacadeService) {
    // HACK: fix toast not presented when offline, due to lazy loading the toast controller.
    // Can be removed once #17450 is resolved: https://github.com/ionic-team/ionic/issues/17450
    this.toastController.create({ animated: false }).then((t) => {
      t.present();
      t.dismiss().catch(err => { return err });
    });
  }

  async successToast(toastMessage) {
    this.toastFacade.showInline({
      message: { line_1: toastMessage, line_2: "" },
      style: { icon: "tick circle success.png", type: "success", duration_ms: 3000 },
    });
  }

  async failureToast(toastMessage) {
    this.toastController.getTop().then((toastElement: HTMLIonToastElement) => {
      toastElement ? toastElement.dismiss() : null;
    }).catch((error) => {
      return error;
    });
    const toast = await this.toastController.create({
      message: toastMessage,
      position: "top",
      cssClass: "redToast",
      duration: 5000,
    });

    return await toast.present();
  }

  async warningToast(toastMessage) {
    this.toastController.getTop().then((toastElement: HTMLIonToastElement) => {
      toastElement ? toastElement.dismiss() : null;
    }).catch((error) => {
      return error;
    });

    const toast = await this.toastController.create({
      message: toastMessage,
      position: "top",
      cssClass: "warningToast",
      duration: 5000,
    });

    return await toast.present();
  }

  async infoToast(toastMessage) {
    this.toastController.getTop().then((toastElement: HTMLIonToastElement) => {
      toastElement ? toastElement.dismiss() : null;
    }).catch((error) => {
      return error;
    });

    const toast = await this.toastController.create({
      message: toastMessage,
      position: "top",
      cssClass: "infoToast",
      duration: 5000,
    });

    return await toast.present();
  }
}
